var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNavUserBold = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8332 13.9998C23.8332 19.1545 19.6545 23.3332 14.4998 23.3332C9.34518 23.3332 5.1665 19.1545 5.1665 13.9998C5.1665 8.84518 9.34518 4.6665 14.4998 4.6665C19.6545 4.6665 23.8332 8.84518 23.8332 13.9998ZM17.2998 11.1998C17.2998 12.7462 16.0462 13.9998 14.4998 13.9998C12.9534 13.9998 11.6998 12.7462 11.6998 11.1998C11.6998 9.65344 12.9534 8.39984 14.4998 8.39984C16.0462 8.39984 17.2998 9.65344 17.2998 11.1998ZM14.4998 21.9332C16.1649 21.9332 17.7102 21.4202 18.9863 20.5436C19.5499 20.1565 19.7908 19.419 19.4631 18.8189C18.7838 17.5747 17.3841 16.7998 14.4998 16.7998C11.6155 16.7998 10.2158 17.5747 9.5365 18.8188C9.20881 19.4189 9.44967 20.1564 10.0133 20.5436C11.2893 21.4202 12.8347 21.9332 14.4998 21.9332Z",
    fill: "url(#paint0_linear_3539_7218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3539_7218",
    x1: 5.1665,
    y1: 4.6665,
    x2: 23.8332,
    y2: 23.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EFF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#199E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107300"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavUserBold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NavUserBold.c9273a4d.svg";
export { ForwardRef as ReactComponent };